<div *ngFor="let item of visibleDoc | keyvalue"><input type="checkbox" [checked]="selected === item.value " disabled> &nbsp; {{item.key}}</div>